import type { CTAConfigJson } from 'myenergy/selectionComponent/loanApplicationButton/generic/DisclaimerRedirectDialog'
import { useState } from 'react'
import DisclaimerRedirectDialog from './DisclaimerRedirectDialog'

export type DisclaimerRedirectDialogConfig = {
  orgId: number
  projectId: number
  systemUuid: string
  paymentOptionId: number
  ctaDialogConfigJson: CTAConfigJson
  integration?: string
  source?: string
  onActionCompleted?: () => void | Promise<void>
}

const useDisclaimerRedirectDialog = (onCloseCallback?: () => void, onContinueCallback?: () => void) => {
  const [state, setState] = useState<
    { open: false; config: undefined } | { open: true; config: DisclaimerRedirectDialogConfig }
  >({
    open: false,
    config: undefined,
  })

  const openDialog = (config: DisclaimerRedirectDialogConfig) => {
    setState({
      open: true,
      config,
    })
  }

  const handleClose = () => {
    if (state.open === false) {
      return
    }
    const onActionCompleted = state.config.onActionCompleted

    setState({
      open: false,
      config: undefined,
    })

    if (onCloseCallback) {
      onCloseCallback()
    }
    void onActionCompleted?.()
  }

  const handleContinue = () => {
    if (state.open === false) {
      return
    }
    const onActionCompleted = state.config.onActionCompleted

    setState({
      open: false,
      config: undefined,
    })

    if (onContinueCallback) {
      onContinueCallback()
    } else if (onCloseCallback) {
      onCloseCallback()
    }
    void onActionCompleted?.()
  }

  const dialogNode = state.open ? (
    <DisclaimerRedirectDialog
      open={true}
      onClose={handleClose}
      onContinue={onContinueCallback ? handleContinue : undefined}
      project_id={state.config.projectId}
      paymentOptionId={state.config.paymentOptionId}
      systemUuid={state.config.systemUuid}
      orgId={state.config.orgId}
      isFullWidth={false}
      ctaDialogConfigJson={state.config.ctaDialogConfigJson}
      integration={state.config.integration}
      source={state.config.source}
    />
  ) : null
  return {
    isOpen: state.open,
    dialogNode,
    openDialog,
    closeDialog: handleClose,
    type: 'DisclaimerRedirectDialog' as const,
  }
}

export default useDisclaimerRedirectDialog
